import setBlockTemplates from './set-block-templates';

export default {
  setBlockTemplates,
};
